import { S3ImageBaseUrl } from "@findemdev/findem-helpers";
import React from "react";
import { CompanyLogoImage } from "../../RaasClientPortal.styled";

interface ICompanyLogoProps {
  label: string;
  logoRef?: string;
}

const handleCompanyLogoError = (
  event: React.SyntheticEvent<HTMLImageElement>,
) => {
  event.currentTarget.style.display = "none";
};

export const CompanyLogo = ({ label, logoRef }: ICompanyLogoProps) => {
  if (!logoRef) return null;

  const logoUrl = `${S3ImageBaseUrl}/${logoRef}.jpg`;

  return (
    <CompanyLogoImage
      alt=""
      aria-hidden={true}
      key={logoUrl}
      onError={handleCompanyLogoError}
      src={logoUrl}
      title={`${label} logo`}
    />
  );
};
